import React, { useState } from 'react'
import FilterRDSPAL from '../components/FilterRDSPAL.jsx'
import WaterLevel from '../components/Chart/WaterLevel.jsx';
import WaterLevelSkeleton from '../components/Chart/WaterLevelSkeleton.jsx';

const HistoryByTrip = ({ onDataToleransi }) => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    return (
        <div className="analytics-panel-content">
            <FilterRDSPAL
                onData={(values) => setData(values)}
                onDataToleransi={onDataToleransi}
                onLoading={(values) => setLoading(values)}
            />
            {loading ? (
                <div className="analytics-metrics">
                    <WaterLevelSkeleton />
                    <WaterLevelSkeleton />
                </div>
            ) : (
                <div className="analytics-metrics">
                    <WaterLevel dataSource={data?.BBM_IN} title="Filling" />
                    <WaterLevel dataSource={data?.BBM_OUT} title="Consumption" />
                </div>
            )}
        </div>
    )
}

export default HistoryByTrip
